import React, { useState, useEffect } from "react";
import * as Material from "@mui/material";
import api from "@helpers/api";

export default function VideosUploadStatusBox() {
    const [video, setVideo] = useState(null);

    useEffect(() => {
        window.addVideoForUpload = async (file, callback) => {
            const newVideo = {
                name: file.name,
                size: file.size,
                progress: 0,
                timeRemaining: null,
            };

            setVideo(newVideo);

            try {
                const { upload_url, final_url } = await getUploadUrl(file);
                const startTime = Date.now();

                await api.directAxios.put(upload_url, file, {
                    headers: {
                        "Content-Type": file.type,
                        Authorization: undefined,
                    },
                    onUploadProgress: (event) => {
                        const progress = Math.round((event.loaded * 100) / event.total);
                        const timeElapsed = (Date.now() - startTime) / 1000;
                        const uploadSpeed = event.loaded / timeElapsed;
                        const bytesRemaining = event.total - event.loaded;
                        const timeRemaining = bytesRemaining / uploadSpeed;

                        setVideo(prev => {
                            if (!prev) return prev;
                            return { ...prev, progress, timeRemaining };
                        });

                        if (progress === 100) {
                            callback({ video: { path: final_url } });
                            setTimeout(() => {
                                setVideo(null);
                            }, 1000); // Clear after 1 second
                        }
                    },
                });
            } catch (error) {
                console.error("Erro no upload do vídeo:", error);
                alert("Erro ao fazer upload do vídeo.");
                setVideo(null);
            }
        };

        return () => {
            window.addVideoForUpload = undefined;
        };
    }, []);

    async function getUploadUrl(file) {
        try {
            const response = await api.post("content/upload-url", {
                filename: file.name,
                content_type: file.type,
                extension: file.name.split(".").pop(),
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao obter URL de upload", error);
            throw new Error("Não foi possível obter a URL de upload.");
        }
    }

    function formatTime(seconds) {
        if (!seconds || !isFinite(seconds)) return "...";
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}m ${secs}s`;
    }

    if (!video) return null;

    return (
        <div className="video-upload-block mb-1 mt-2">
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                <small className="bold">{video.name}</small>
                {video.timeRemaining !== null && (
                    <small style={{ opacity: 0.7 }}>{formatTime(video.timeRemaining)} restantes</small>
                )}
            </div>
            <Material.LinearProgress
                variant="determinate"
                value={video.progress}
                style={{ height: '8px', borderRadius: '4px' }}
            />
            {video.progress === 100 && <small style={{ color: 'var(--success)', marginTop: '4px', display: 'block' }}>Upload concluído! Processando...</small>}
        </div>
    );
}
